// Generic card languages that work across all trading card games

export type CardLanguage = 
  | 'english'
  | 'japanese'
  | 'korean'
  | 'chinese_simplified'
  | 'chinese_traditional'
  | 'french'
  | 'german'
  | 'italian'
  | 'spanish'
  | 'portuguese'
  | 'dutch'
  | 'russian'
  | 'thai'
  | 'indonesian'
  | 'other';

export const LANGUAGE_OPTIONS: { value: CardLanguage; label: string; flag: string }[] = [
  { value: 'english', label: 'English', flag: '🇺🇸' },
  { value: 'japanese', label: 'Japanese', flag: '🇯🇵' },
  { value: 'korean', label: 'Korean', flag: '🇰🇷' },
  { value: 'chinese_simplified', label: 'Chinese (Simplified)', flag: '🇨🇳' },
  { value: 'chinese_traditional', label: 'Chinese (Traditional)', flag: '🇹🇼' },
  { value: 'french', label: 'French', flag: '🇫🇷' },
  { value: 'german', label: 'German', flag: '🇩🇪' },
  { value: 'italian', label: 'Italian', flag: '🇮🇹' },
  { value: 'spanish', label: 'Spanish', flag: '🇪🇸' },
  { value: 'portuguese', label: 'Portuguese', flag: '🇧🇷' },
  { value: 'dutch', label: 'Dutch', flag: '🇳🇱' },
  { value: 'russian', label: 'Russian', flag: '🇷🇺' },
  { value: 'thai', label: 'Thai', flag: '🇹🇭' },
  { value: 'indonesian', label: 'Indonesian', flag: '🇮🇩' },
  { value: 'other', label: 'Other', flag: '🌐' },
];
